import { httpGet, httpPost, httpPut, httpDelete } from "./http";
import { setAuthToken } from "./http";

export const createApi = () => {
  return {
    auth: {
      login: async (payload: { username: string; password: string }) => {
        const res = await httpPost<any>("/auth/login/username", payload);
        if (res.ok && (res as any).data?.token)
          setAuthToken((res as any).data.token);
        return res;
      },
      loginEmail: async (payload: { username: string; password: string }) => {
        const res = await httpPost<any>("/auth/login/email", payload);
        if (res.ok && (res as any).data?.token)
          setAuthToken((res as any).data.token);
        return res;
      },
      logout: async () => {
        setAuthToken(null);
        return { ok: true } as any;
      },
      // ... (other auth methods)
    },

    emailLog: {
        getLogs: async (payload: { page: number; pageSize: number; userId?: number }) =>
            httpPost<any>("/email-logs", payload),
        getById: async (id: number) => httpGet<any>("/email-logs/" + id),
    },
    
    reservationRequestType: {
      getAll: async () => httpGet<any[]>("/reservation-request-type"),
      getById: async (id: number) =>
        httpGet<any>("/reservation-request-type/" + id),
      create: async (payload: any) =>
        httpPost<void>("/reservation-request-type", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/reservation-request-type/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/reservation-request-type/" + id),
    },

    aircraftCharterAvailable: {
      getAll: async () => httpGet<any[]>("/aircraftcharteravailable?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/aircraftcharteravailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftcharteravailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftcharteravailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircraftcharteravailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/aircraftcharteravailable/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async () =>
        httpGet<any[]>("/aircraftcharteravailable/GetMyAll"),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/aircraftcharteravailable/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftcharteravailable/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftcharteravailable/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftcharteravailable/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftcharteravailable/" + id + "/admin-renew"),
    },

    aircraftCharterWanted: {
      getAll: async () => httpGet<any[]>("/aircraftcharterwanted?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/aircraftcharterwanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftcharterwanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftcharterwanted/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircraftcharterwanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/aircraftcharterwanted/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async () => httpGet<any[]>("/aircraftcharterwanted/GetMyAll"),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/aircraftcharterwanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftcharterwanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftcharterwanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftcharterwanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftcharterwanted/" + id + "/admin-renew"),
    },

    aircraftsaleleaseAvailable: {
      getAll: async () => httpGet<any[]>("/aircraftsaleleaseavailable?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/aircraftsaleleaseavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftsaleleaseavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircraftsaleleaseavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/aircraftsaleleaseavailable/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/aircraftsaleleaseavailable/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>(
          "/aircraftsaleleaseavailable/" + id + "/active/" + status,
        ),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/admin-renew"),
    },

    aircraftSaleLeaseAvailable: {
      getAll: async () => httpGet<any[]>("/aircraftsaleleaseavailable?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/aircraftsaleleaseavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftsaleleaseavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircraftsaleleaseavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/aircraftsaleleaseavailable/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/aircraftsaleleaseavailable/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>(
          "/aircraftsaleleaseavailable/" + id + "/active/" + status,
        ),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftsaleleaseavailable/" + id + "/admin-renew"),
    },

    aircraftsaleleaseWanted: {
      getAll: async () => httpGet<any[]>("/aircraftsaleleasewanted?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/aircraftsaleleasewanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftsaleleasewanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircraftsaleleasewanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/aircraftsaleleasewanted/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/aircraftsaleleasewanted/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/admin-renew"),
    },

    aircraftSaleLeaseWanted: {
      getAll: async () => httpGet<any[]>("/aircraftsaleleasewanted?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/aircraftsaleleasewanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftsaleleasewanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircraftsaleleasewanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/aircraftsaleleasewanted/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/aircraftsaleleasewanted/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftsaleleasewanted/" + id + "/admin-renew"),
    },
    
    chat: {
      getAll: async () => httpGet<any[]>("/chat/all"),
      getInbox: async (userId: number) =>
        httpGet<any[]>("/chat/inbox/" + userId),
      getConversation: async (
        conversationKey: string,
        skip: number = 0,
        take: number = 30,
      ) =>
        httpGet<any>(
          `/chat/conversation/${conversationKey}?skip=${skip}&take=${take}`,
        ),
      send: async (payload: any) => httpPost<void>("/chat/send", payload),
      markAsRead: async (conversationKey: string) =>
        httpPost<void>("/chat/read/" + conversationKey),
      getUnreadCount: async () => httpGet<number>("/chat/unread-count"),
    },
    
    aircraftRequest: {
      getAll: async () => httpGet<any[]>("/aircraft-request"),
      getById: async (id: number) => httpGet<any>("/aircraft-request/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraft-request", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraft-request/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/aircraft-request/" + id),
      getMyReceivedRequests: async (requestKey: string) =>
        httpGet<any[]>(
          "/aircraft-request/GetMyAll/Request/Receive/" + requestKey,
        ),
      getMySentRequests: async (requestKey: string) =>
        httpGet<any[]>("/aircraft-request/GetMyAll/Request/Send/" + requestKey),
    },

    aircraftType: {
      getAll: async () => httpGet<any[]>("/aircrafttype"),
      getById: async (id: number) => httpGet<any>("/aircrafttype/" + id),
      create: async (payload: any) => httpPost<void>("/aircrafttype", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircrafttype/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/aircrafttype/" + id),
    },

    aircraftTypeModel: {
      getAll: async () => httpGet<any[]>("/aircrafttypemodel"),
      getById: async (id: number) => httpGet<any>("/aircrafttypemodel/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircrafttypemodel", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircrafttypemodel/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/aircrafttypemodel/" + id),
    },

    aircraftWanted: {
      getAll: async () => httpGet<any[]>("/aircraftwanted"),
      getById: async (id: number) => httpGet<any>("/aircraftwanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/aircraftwanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aircraftwanted/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/aircraftwanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>("/aircraftwanted/" + id + "/confirm-status/" + status),
      getMyAll: async () => httpGet<any[]>("/aircraftwanted/GetMyAll"),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/aircraftwanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/aircraftwanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/aircraftwanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/aircraftwanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/aircraftwanted/" + id + "/admin-renew"),
    },

    airport: {
      getAll: async () => httpGet<any[]>("/airport"),
      getById: async (id: number) => httpGet<any>("/airport/" + id),
      getByCityId: async (cityId: number) =>
        httpGet<any[]>("/airport/by-city/" + cityId),
      create: async (payload: any) => httpPost<void>("/airport", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/airport/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/airport/" + id),
    },

    aogRequest: {
      getAll: async () => httpGet<any[]>("/aogrequest"),
      getById: async (id: number) => httpGet<any>("/aogrequest/" + id),
      create: async (payload: any) => httpPost<void>("/aogrequest", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/aogrequest/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/aogrequest/" + id),
    },

    banner: {
      getAll: async () => httpGet<any[]>("/banner"),
      getById: async (id: number) => httpGet<any>("/banner/" + id),
      create: async (payload: any) => httpPost<void>("/banner", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/banner/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/banner/" + id),
    },

    businessJetAvailable: {
      getAll: async () => httpGet<any[]>("/businessjetavailable?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/businessjetavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/businessjetavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/businessjetavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/businessjetavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/businessjetavailable/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/businessjetavailable/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/businessjetavailable/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/businessjetavailable/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/businessjetavailable/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/businessjetavailable/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/businessjetavailable/" + id + "/admin-renew"),
    },

    businessJetWanted: {
      getAll: async () => httpGet<any[]>("/businessjetwanted?isAll=true"),
      getById: async (id: number) => httpGet<any>("/businessjetwanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/businessjetwanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/businessjetwanted/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/businessjetwanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/businessjetwanted/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/businessjetwanted/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/businessjetwanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/businessjetwanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/businessjetwanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/businessjetwanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/businessjetwanted/" + id + "/admin-renew"),
    },

    city: {
      getAll: async () => httpGet<any[]>("/city"),
      getById: async (id: number) => httpGet<any>("/city/" + id),
      getByCountryId: async (countryId: number) =>
        httpGet<any[]>("/city/by-country/" + countryId),
      create: async (payload: any) => httpPost<void>("/city", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/city/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/city/" + id),
    },

    company: {
      getAll: async () => httpGet<any[]>("/company"),
      getById: async (id: number) => httpGet<any>("/company/" + id),
      create: async (payload: any) => httpPost<void>("/company", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/company/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/company/" + id),
      userCreate: async (payload: any) =>
        httpPost<void>("/company/user/create", payload),
    },

    showcaseCompany: {
      getAll: async () => httpGet<any[]>("/showcase-company"),
      getEligible: async () => httpGet<any[]>("/showcase-company/eligible"),
      create: async (payload: { companyId: number; displayOrder?: number }) =>
        httpPost<void>("/showcase-company", payload),
      delete: async (id: number) => httpDelete<void>("/showcase-company/" + id),
    },

    companyModuleSubscription: {
      getAll: async () => httpGet<any[]>("/companymodulesubscription"),
      getById: async (id: number) =>
        httpGet<any>("/companymodulesubscription/" + id),
      create: async (payload: any) =>
        httpPost<void>("/companymodulesubscription/create", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/companymodulesubscription/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/companymodulesubscription/" + id),
      updateConfirmStatus: async (id: number, confirmStatus: number) =>
        httpPost<void>(
          "/companymodulesubscription/" +
            id +
            "/confirm-status/" +
            confirmStatus,
        ),
      getDashbordById: async (id: number) =>
        httpGet<any>("/companymodulesubscription/dashboard/" + id),
    },

    companyPackageItemBalance: {
      getAll: async () => httpGet<any[]>("/companypackageitembalance"),
      getById: async (id: number) =>
        httpGet<any>("/companypackageitembalance/" + id),
      create: async (payload: any) =>
        httpPost<void>("/companypackageitembalance", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/companypackageitembalance/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/companypackageitembalance/" + id),
    },

    companyPackageItemUsageLog: {
      getAll: async () => httpGet<any[]>("/companypackageitemusagelog"),
      getById: async (id: number) =>
        httpGet<any>("/companypackageitemusagelog/" + id),
      create: async (payload: any) =>
        httpPost<void>("/companypackageitemusagelog", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/companypackageitemusagelog/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/companypackageitemusagelog/" + id),
    },

    companyUser: {
      getAll: async () => httpGet<any[]>("/companyuser"),
      getById: async (id: number) => httpGet<any>("/companyuser/" + id),
      create: async (payload: any) => httpPost<void>("/companyuser", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/companyuser/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/companyuser/" + id),
      getByCompanyId: async (companyId: number) =>
        httpGet<any[]>("/companyuser/by-company/" + companyId),
    },

    continent: {
      getAll: async () => httpGet<any[]>("/continent"),
      getById: async (id: number) => httpGet<any>("/continent/" + id),
      create: async (payload: any) => httpPost<void>("/continent", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/continent/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/continent/" + id),
    },

    country: {
      getAll: async () => httpGet<any[]>("/country"),
      getById: async (id: number) => httpGet<any>("/country/" + id),
      getByContinentId: async (continentId: number) =>
        httpGet<any[]>("/country/by-continent/" + continentId),
      create: async (payload: any) => httpPost<void>("/country", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/country/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/country/" + id),
    },

    dynamicPage: {
      getAll: async () => httpGet<any[]>("/dynamicpage"),
      getById: async (id: number) => httpGet<any>("/dynamicpage/" + id),
      create: async (payload: any) => httpPost<void>("/dynamicpage", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/dynamicpage/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/dynamicpage/" + id),
    },

    emailVerification: {
      getAll: async () => httpGet<any[]>("/emailverification"),
      getById: async (id: number) => httpGet<any>("/emailverification/" + id),
      create: async (payload: any) =>
        httpPost<void>("/emailverification", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/emailverification/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/emailverification/" + id),
    },

    emailTemplate: {
      getAll: async () => httpGet<any[]>("/email-template"),
      getById: async (id: number) => httpGet<any>("/email-template/" + id),
      create: async (payload: any) =>
        httpPost<void>("/email-template", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/email-template/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/email-template/" + id),
    },

    enginesaleleasaAvailable: {
      getAll: async () => httpGet<any[]>("/enginesaleleasavailable?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/enginesaleleasavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/enginesaleleasavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/enginesaleleasavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/enginesaleleasavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/enginesaleleasavailable/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/enginesaleleasavailable/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/admin-renew"),
    },

    engineSaleLeaseAvailable: {
      getAll: async () => httpGet<any[]>("/enginesaleleasavailable?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/enginesaleleasavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/enginesaleleasavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/enginesaleleasavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/enginesaleleasavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/enginesaleleasavailable/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/enginesaleleasavailable/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/enginesaleleasavailable/" + id + "/admin-renew"),
    },

    enginesaleleasaWanted: {
      getAll: async () => httpGet<any[]>("/enginesaleleaswanted?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/enginesaleleaswanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/enginesaleleaswanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/enginesaleleaswanted/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/enginesaleleaswanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/enginesaleleaswanted/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/enginesaleleaswanted/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/admin-renew"),
    },

    engineSaleLeaseWanted: {
      getAll: async () => httpGet<any[]>("/enginesaleleaswanted?isAll=true"),
      getById: async (id: number) =>
        httpGet<any>("/enginesaleleaswanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/enginesaleleaswanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/enginesaleleaswanted/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/enginesaleleaswanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/enginesaleleaswanted/" + id + "/confirm-status/" + status,
        ),
      getMyAll: async (tradeType: number) =>
        httpGet<any[]>("/enginesaleleaswanted/GetMyAll/" + tradeType),
      setActive: async (id: number, status: boolean) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/active/" + status),
      setPriority: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/Priority"),
      setAnnouncement: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/Announcement"),
      setTMMS: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/TMMS"),
      adminRenew: async (id: number) =>
        httpPost<void>("/enginesaleleaswanted/" + id + "/admin-renew"),
    },
    engineType: {
      getAll: async () => httpGet<any[]>("/engine-type"),
      getById: async (id: number) => httpGet<any>("/engine-type/" + id),
      create: async (payload: any) => httpPost<void>("/engine-type", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/engine-type/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/engine-type/" + id),
    },

    location: {
      summary: async () => httpGet<any>("/location/summary"),
    },

    marketingEmail: {
      getAll: async () => httpGet<any>("/marketing-email"),
      create: async (payload: any) => httpPost<any>("/marketing-email", payload),
      bulkCreate: async (payload: any[]) => httpPost<any>("/marketing-email/bulk", payload),
      delete: async (id: number) => httpDelete<any>("/marketing-email/" + id),
      uploadExcel: async (file: File) => {
        const formData = new FormData();
        formData.append("file", file);
        return await httpPost<any>("/marketing-email/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      },
    },

    module: {
      getAll: async () => httpGet<any[]>("/module"),
      getById: async (id: number) => httpGet<any>("/module/" + id),
      create: async (payload: any) => httpPost<void>("/module", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/module/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/module/" + id),
    },

    package: {
      getAll: async () => httpGet<any[]>("/package"),
      getById: async (id: number) => httpGet<any>("/package/" + id),
      create: async (payload: any) => httpPost<void>("/package", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/package/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/package/" + id),
      getByModuleId: async (moduleId: number) =>
        httpGet<any[]>("/package/by-module/" + moduleId),
    },

    packageItem: {
      getAll: async () => httpGet<any[]>("/packageitem"),
      getById: async (id: number) => httpGet<any>("/packageitem/" + id),
      create: async (payload: any) => httpPost<void>("/packageitem", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/packageitem/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/packageitem/" + id),
    },

    packageItemLink: {
      getAll: async () => httpGet<any[]>("/packageitemlink"),
      getById: async (id: number) => httpGet<any>("/packageitemlink/" + id),
      create: async (payload: any) =>
        httpPost<void>("/packageitemlink", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/packageitemlink/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/packageitemlink/" + id),
      getByPackageId: async (packageId: number) =>
        httpGet<any[]>("/packageitemlink/by-package/" + packageId),
    },

    permission: {
      getAll: async () => httpGet<any[]>("/permission"),
      getById: async (id: number) => httpGet<any>("/permission/" + id),
      create: async (payload: any) => httpPost<void>("/permission", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/permission/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/permission/" + id),
    },

    Role: {
      getAll: async () => httpGet<any[]>("/role"),
      getById: async (id: number) => httpGet<any>("/role/" + id),
      create: async (payload: any) => httpPost<void>("/role", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/role/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/role/" + id),
    },

    rolePermission: {
      getAll: async () => httpGet<any[]>("/rolepermission"),
      getById: async (id: number) => httpGet<any>("/rolepermission/" + id),
      create: async (payload: any) =>
        httpPost<void>("/rolepermission", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/rolepermission/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/rolepermission/" + id),
    },

    userRole: {
      getAll: async () => httpGet<any[]>("/userrole"),
      getById: async (id: number) => httpGet<any>("/userrole/" + id),
      create: async (payload: any) => httpPost<any>("/userrole", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/userrole/" + id, payload), // Added update endpoint
      delete: async (id: number) => httpDelete<any>("/userrole/" + id),
    },

    user: {
      getAll: async () => httpGet<any[]>("/user"),
      getById: async (id: number) => httpGet<any>("/user/" + id),
      setBlockUnblock: async (id: number) =>
        httpGet<any>("/user/block-unblock/" + id),
      setEmailVerify: async (id: number) =>
        httpGet<any>("/user/set-email-verify/" + id),
      create: async (payload: any) => httpPost<void>("/user", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/user/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/user/" + id),
      forgetPasswordByEmail: async (email: string) =>
        httpPost<boolean>("/user/forget-password/email", email),

      forgetPasswordByUsername: async (username: string) =>
        httpPost<boolean>("/user/forget-password/username", username),
    },

    wetLeaseAOG: {
      getAll: async () => httpGet<any[]>("/wetleaseaog?isAll=true"),
      getById: async (id: number) => httpGet<any>("/wetleaseaog/" + id),
      create: async (payload: any) => httpPost<void>("/wetleaseaog", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/wetleaseaog/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/wetleaseaog/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>("/wetleaseaog/" + id + "/confirm-status/" + status),
    },

    wetleaseAOG: {
      getAll: async () => httpGet<any[]>("/wetleaseaog?isAll=true"),
      getById: async (id: number) => httpGet<any>("/wetleaseaog/" + id),
      create: async (payload: any) => httpPost<void>("/wetleaseaog", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/wetleaseaog/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/wetleaseaog/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>("/wetleaseaog/" + id + "/confirm-status/" + status),
    },

    wetLeaseAvailable: {
      getAll: async () => httpGet<any[]>("/wetleaseavailable?isAll=true"),
      getById: async (id: number) => httpGet<any>("/wetleaseavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/wetleaseavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/wetleaseavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/wetleaseavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/wetleaseavailable/" + id + "/confirm-status/" + status,
        ),
      adminRenew: async (id: number) =>
        httpPost<void>("/wetleaseavailable/" + id + "/admin-renew"),
    },

    wetleaseAvailable: {
      getAll: async () => httpGet<any[]>("/wetleaseavailable?isAll=true"),
      getById: async (id: number) => httpGet<any>("/wetleaseavailable/" + id),
      create: async (payload: any) =>
        httpPost<void>("/wetleaseavailable", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/wetleaseavailable/" + id, payload),
      delete: async (id: number) =>
        httpDelete<void>("/wetleaseavailable/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>(
          "/wetleaseavailable/" + id + "/confirm-status/" + status,
        ),
      adminRenew: async (id: number) =>
        httpPost<void>("/wetleaseavailable/" + id + "/admin-renew"),
    },

    wetLeaseWanted: {
      getAll: async () => httpGet<any[]>("/wetleasewanted?isAll=true"),
      getById: async (id: number) => httpGet<any>("/wetleasewanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/wetleasewanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/wetleasewanted/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/wetleasewanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>("/wetleasewanted/" + id + "/confirm-status/" + status),
      adminRenew: async (id: number) =>
        httpPost<void>("/wetleasewanted/" + id + "/admin-renew"),
    },

    wetleaseWanted: {
      getAll: async () => httpGet<any[]>("/wetleasewanted?isAll=true"),
      getById: async (id: number) => httpGet<any>("/wetleasewanted/" + id),
      create: async (payload: any) =>
        httpPost<void>("/wetleasewanted", payload),
      update: async (id: number, payload: any) =>
        httpPost<void>("/wetleasewanted/" + id, payload),
      delete: async (id: number) => httpDelete<void>("/wetleasewanted/" + id),
      confirmStatus: async (id: number, status: number) =>
        httpPost<void>("/wetleasewanted/" + id + "/confirm-status/" + status),
      adminRenew: async (id: number) =>
        httpPost<void>("/wetleasewanted/" + id + "/admin-renew"),
    },

    dashboard: {
      getMapData: async (count: number) =>
        httpGet<any[]>("/dashboard/map/lastdays/" + count),
      getInvoices: async () => httpGet<any[]>("/dashboard/invoices/all"),
      sendInvoice: async (payload: FormData) =>
        httpPost<boolean>("/dashboard/send-invoice", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      getLocalSupportsAll: async () => httpGet<any[]>("/dashboard/addons/local/all"),
      getLegalSupportsAll: async () => httpGet<any[]>("/dashboard/addons/legal/all"),
    },

    addons: {
      getLocalSupports: async () => httpGet<any>("/addons/local-support"),
      createLocalSupport: async (payload: any) =>
        httpPost<any>("/addons/local-support", payload),
      updateLocalSupport: async (id: number, payload: any) =>
        httpPost<any>("/addons/local-support/" + id, payload),
      deleteLocalSupport: async (id: number) =>
        httpDelete<any>("/addons/local-support/" + id),

      getLegalSupports: async () => httpGet<any>("/addons/legal-support"),
      createLegalSupport: async (payload: FormData) =>
        httpPost<any>("/addons/legal-support", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      updateLegalSupport: async (id: number, payload: FormData) =>
        httpPost<any>("/addons/legal-support/" + id, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        }),
      deleteLegalSupport: async (id: number) =>
        httpDelete<any>("/addons/legal-support/" + id),
    },

    media: {
      getByOwner: async (payload: {
        ownerType: number;
        ownerId: number;
        mediaType?: number;
      }) => {
        const qs =
          payload.mediaType !== undefined
            ? "?mediaType=" + payload.mediaType
            : "";

        return await httpGet<any>(
          `/media/owner/${payload.ownerType}/${payload.ownerId}${qs}`,
        );
      },

      uploadSingle: async (payload: {
        file: File;
        ownerType: number;
        ownerId: number;
        mediaType: number;
        isPrimary: boolean;
        description?: string;
      }) => {
        if (payload.isPrimary === undefined)
          throw new Error("isPrimary is required");

        const form = new FormData();
        form.append("file", payload.file);
        form.append("ownerType", String(payload.ownerType));
        form.append("ownerId", String(payload.ownerId));
        form.append("mediaType", String(payload.mediaType));
        form.append("isPrimary", String(payload.isPrimary));
        if (payload.description)
          form.append("description", payload.description);

        return await httpPost<any>("/media/upload", form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      },

      uploadMultiple: async (payload: {
        files: File[];
        ownerType: number;
        ownerId: number;
        mediaType: number;
        description?: string;
      }) => {
        const form = new FormData();
        payload.files.forEach((f) => form.append("files", f));
        form.append("ownerType", String(payload.ownerType));
        form.append("ownerId", String(payload.ownerId));
        form.append("mediaType", String(payload.mediaType));
        if (payload.description)
          form.append("description", payload.description);

        return await httpPost<any>("/media/upload-multi", form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      },

      update: async (
        id: number,
        payload: {
          ownerType: number;
          isPrimary?: boolean;
          description?: string;
          mediaType?: number;
          file?: File;
        },
      ) => {
        const form = new FormData();
        form.append("ownerType", String(payload.ownerType));

        if (payload.isPrimary !== undefined)
          form.append("isPrimary", String(payload.isPrimary));

        if (payload.description !== undefined)
          form.append("description", payload.description);

        if (payload.mediaType !== undefined)
          form.append("mediaType", String(payload.mediaType));

        if (payload.file) form.append("file", payload.file);

        return await httpPost<void>(`/media/${id}`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      },

      delete: async (id: number) => httpDelete<void>(`/media/${id}`),
    },

    adminTender: {
      getAll: async (params?: {
        moduleId?: number;
        status?: number;
        companyId?: number;
        from?: string;
        to?: string;
        page?: number;
        pageSize?: number;
      }) => {
        const query = new URLSearchParams();
        if (params?.moduleId != null) query.append("moduleId", String(params.moduleId));
        if (params?.status != null) query.append("status", String(params.status));
        if (params?.companyId != null) query.append("companyId", String(params.companyId));
        if (params?.from) query.append("from", params.from);
        if (params?.to) query.append("to", params.to);
        if (params?.page != null) query.append("page", String(params.page));
        if (params?.pageSize != null) query.append("pageSize", String(params.pageSize));
        const qs = query.toString();
        return httpGet<any[]>(`/admin/tender${qs ? "?" + qs : ""}`);
      },
      getById: async (id: number) => httpGet<any>(`/admin/tender/${id}`),
      getStats: async () => httpGet<any>("/admin/tender/stats"),
      approve: async (id: number) => httpPost<boolean>(`/admin/tender/${id}/approve`, {}),
      reject: async (id: number, reason: string) =>
        httpPost<boolean>(`/admin/tender/${id}/reject`, JSON.stringify(reason)),
      returnTender: async (id: number, reason: string) =>
        httpPost<boolean>(`/admin/tender/${id}/return`, JSON.stringify(reason)),
      getOffers: async (id: number) => httpGet<any[]>(`/admin/tender/${id}/offers`),
      getOfferDetail: async (tenderId: number, offerId: number) =>
        httpGet<any>(`/admin/tender/${tenderId}/offers/${offerId}`),
      restoreOffer: async (tenderId: number, offerId: number) =>
        httpPost<boolean>(`/admin/tender/${tenderId}/offers/${offerId}/restore`, {}),
      getShortlist: async (id: number) => httpGet<any[]>(`/admin/tender/${id}/shortlist`),
      getAwards: async (id: number) => httpGet<any[]>(`/admin/tender/${id}/awards`),
      getAuditLog: async (id: number) => httpGet<any[]>(`/admin/tender/${id}/audit`),
    },

    adminScm: {
      getAll: async (params?: {
        charterType?: number;
        status?: number;
        companyId?: number;
        fromIata?: string;
        toIata?: string;
        fromDate?: string;
        toDate?: string;
        search?: string;
        page?: number;
        pageSize?: number;
      }) => {
        const query = new URLSearchParams();
        if (params?.charterType != null) query.append("charterType", String(params.charterType));
        if (params?.status != null) query.append("status", String(params.status));
        if (params?.companyId != null) query.append("companyId", String(params.companyId));
        if (params?.fromIata) query.append("fromIata", params.fromIata);
        if (params?.toIata) query.append("toIata", params.toIata);
        if (params?.fromDate) query.append("fromDate", params.fromDate);
        if (params?.toDate) query.append("toDate", params.toDate);
        if (params?.search) query.append("search", params.search);
        if (params?.page != null) query.append("page", String(params.page));
        if (params?.pageSize != null) query.append("pageSize", String(params.pageSize));
        const qs = query.toString();
        return httpGet<any>(`/admin/scm${qs ? "?" + qs : ""}`);
      },
      getStats: async () => httpGet<any>("/admin/scm/dashboard/stats"),
      getById: async (id: number) => httpGet<any>(`/admin/scm/${id}`),
      updateStatus: async (id: number, payload: { newStatus: number; internalNote?: string }) =>
        httpPut<boolean>(`/admin/scm/${id}/status`, payload),
      addMatch: async (
        id: number,
        payload: {
          operatorCompanyId: number;
          notes?: string;
          hasOffer?: boolean;
          offerAmount?: number | null;
          offerCurrency?: string;
        },
      ) => httpPost<any>(`/admin/scm/${id}/matches`, payload),
      deleteMatch: async (id: number, matchId: number) =>
        httpDelete<boolean>(`/admin/scm/${id}/matches/${matchId}`),
    },
  };
};
